export const VANILLA_SECONDARY_ROUTES = [
    {
        path: 'menu',
        outlet: 'overlay',
        loadChildren: () => import('@frontend/vanilla/features/account-menu').then((m) => m.ROUTES),
    },
];
